export const leadQueueFeatureKey = 'leadQueue';
